export const leadQueueFeatureKey = 'leadQueue';
